module.exports = __webpack_public_path__ + "static/media/pie-chart.ae208d8e.png";